var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDosingBellowsPumpOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 31",
    style: {
      enableBackground: "new 0 0 75 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A7084;}\r\n\t.st1{fill:#8B90A0;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#E9CC63;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 13.58,
    className: "st3",
    width: 75,
    height: 3.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.91,28.56L25.91,28.56c-1.59,0-2.89-1.3-2.89-2.89V5.33c0-1.59,1.3-2.89,2.89-2.89h0 c1.59,0,2.89,1.3,2.89,2.89v20.33C28.8,27.26,27.5,28.56,25.91,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.91,28.88c-1.77,0-3.22-1.43-3.22-3.18V5.3c0-1.75,1.44-3.18,3.22-3.18s3.22,1.43,3.22,3.18v20.4 C29.12,27.45,27.68,28.88,25.91,28.88z M25.91,2.76c-1.42,0-2.57,1.14-2.57,2.54v20.4c0,1.4,1.15,2.54,2.57,2.54 s2.57-1.14,2.57-2.54V5.3C28.47,3.9,27.32,2.76,25.91,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.69,28.56L31.69,28.56c-1.59,0-2.89-1.3-2.89-2.89l0-20.33c0-1.59,1.3-2.89,2.89-2.89h0 c1.59,0,2.89,1.3,2.89,2.89v20.33C34.58,27.26,33.28,28.56,31.69,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.69,28.88c-1.77,0-3.22-1.43-3.22-3.18V5.3c0-1.75,1.44-3.18,3.22-3.18c1.77,0,3.22,1.43,3.22,3.18v20.4 C34.91,27.45,33.46,28.88,31.69,28.88z M31.69,2.76c-1.42,0-2.57,1.14-2.57,2.54v20.4c0,1.4,1.15,2.54,2.57,2.54 c1.42,0,2.57-1.14,2.57-2.54V5.3C34.26,3.9,33.11,2.76,31.69,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.47,28.56L37.47,28.56c-1.59,0-2.89-1.3-2.89-2.89V5.33c0-1.59,1.3-2.89,2.89-2.89h0 c1.59,0,2.89,1.3,2.89,2.89v20.33C40.37,27.26,39.06,28.56,37.47,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.47,28.88c-1.77,0-3.22-1.43-3.22-3.18V5.3c0-1.75,1.44-3.18,3.22-3.18c1.77,0,3.22,1.43,3.22,3.18v20.4 C40.69,27.45,39.25,28.88,37.47,28.88z M37.47,2.76c-1.42,0-2.57,1.14-2.57,2.54v20.4c0,1.4,1.15,2.54,2.57,2.54 s2.57-1.14,2.57-2.54V5.3C40.04,3.9,38.89,2.76,37.47,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.26,28.56L43.26,28.56c-1.59,0-2.89-1.3-2.89-2.89V5.33c0-1.59,1.3-2.89,2.89-2.89h0 c1.59,0,2.89,1.3,2.89,2.89v20.33C46.15,27.26,44.85,28.56,43.26,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.26,28.88c-1.77,0-3.22-1.43-3.22-3.18V5.3c0-1.75,1.44-3.18,3.22-3.18c1.77,0,3.22,1.43,3.22,3.18v20.4 C46.47,27.45,45.03,28.88,43.26,28.88z M43.26,2.76c-1.42,0-2.57,1.14-2.57,2.54v20.4c0,1.4,1.15,2.54,2.57,2.54 c1.42,0,2.57-1.14,2.57-2.54V5.3C45.82,3.9,44.67,2.76,43.26,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.04,28.56L49.04,28.56c-1.59,0-2.89-1.3-2.89-2.89V5.33c0-1.59,1.3-2.89,2.89-2.89h0 c1.59,0,2.89,1.3,2.89,2.89v20.33C51.93,27.26,50.63,28.56,49.04,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.04,28.88c-1.77,0-3.22-1.43-3.22-3.18V5.3c0-1.75,1.44-3.18,3.22-3.18c1.77,0,3.22,1.43,3.22,3.18v20.4 C52.26,27.45,50.81,28.88,49.04,28.88z M49.04,2.76c-1.42,0-2.57,1.14-2.57,2.54v20.4c0,1.4,1.15,2.54,2.57,2.54 c1.42,0,2.57-1.14,2.57-2.54V5.3C51.61,3.9,50.46,2.76,49.04,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.48,
    y: 0.32,
    className: "st3",
    width: 6.53,
    height: 30.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.34,31h-7.18V0h7.18V31z M16.81,30.36h5.89V0.64h-5.89V30.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.99,
    y: 0.32,
    className: "st3",
    width: 6.53,
    height: 30.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.84,31h-7.18V0h7.18V31z M52.31,30.36h5.88V0.64h-5.88V30.36z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosingBellowsPumpOn);
export default __webpack_public_path__ + "static/media/dosing_bellows_pump_on.e61ef2e20b4ecaec83649c23f6fafe13.svg";
export { ForwardRef as ReactComponent };